import { format, isValid } from "date-fns";

export const safeDateFormat = (
  value: Date | string,
  showTime: boolean = false
): string => {
  try {
    const date = new Date(value);
    if (isValid(date)) {
      return format(date, showTime ? "dd MMMM yyyy, HH:mm" : "dd MMMM yyyy");
    }
    return "Invalid Date";
  } catch (error) {
    console.error("Error formatting date:", error);
    return "Invalid Date";
  }
};
